export default {
	"exceptionType": {
		"typeName": "ชื่อประเภท",
		"type": "ประเภทข้อยกเวัน",
		"autoMonitor": "การควบคุมอัตโนมัติ",
		"exceptionCode": "รหัสข้อยกเว้น",
		"code": "รหัส",
		"attr": "คุณลักษณะ",
		"level": "ระดับ",
		"tabTitle1": "ข้อมูลข้อยกเว้น",
		"defaultLevel": "ระดับเริ่มต้น",
		"hourLimit": "ขีดจำกัดเวลาในการประมวลผล",
		"reason": "ผิดปกติ",
		"reasonName": "ระบุสาเหตุ",
		"addTitle": "สร้างประเภทข้อยกเว้น"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/exceptionType/exceptionType.js